export default "<app-navbar></app-navbar>\n\n<app-search></app-search>\n\n"